export enum ImageSizeType {
  Thumbnail = 'thumbnail',
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
}
